module.exports = __webpack_public_path__ + "static/media/nature-hearing-aid-logo-png.fe22f1ff.png";